import { useAuth } from '../contexts/AuthContext';
import { hasPermission } from '../config/roles';

export const usePermissions = () => {
  const { currentAgent } = useAuth();
  const role = currentAgent?.role || 'user';

  return {
    role,
    agentId: currentAgent?.agent_id,
    canCreateOrders: hasPermission(role, 'canCreateOrders'),
    canViewOrders: hasPermission(role, 'canViewOrders'),
    canBookDemos: hasPermission(role, 'canBookDemos'),
    canViewDocuments: hasPermission(role, 'canViewDocuments'),
    canViewMyUploads: hasPermission(role, 'canViewMyUploads'),
    canAccessAdminPanel: hasPermission(role, 'canAccessAdminPanel'),
    canAccessTeamLeaderPanel: hasPermission(role, 'canAccessTeamLeaderPanel'),
    canViewTeamData: hasPermission(role, 'canViewTeamData'),
    hasPermission: (permission) => hasPermission(role, permission),
    isAdmin: role === 'admin',
    isTeamLeader: role === 'teamLeader',
    isUser: role === 'user',
    isHost: role === 'host',
    isBooking: role === 'booking'
  };
};
